import { FC, memo } from "react";
import { StyledMain, StyledMainSection } from "./Main.styled";

import { AnonymousMainProps } from "./Main.interface";
import { Navigation } from "#/organisms";

const AnonymousMain: FC<AnonymousMainProps> = ({ children, navigation }) => {
  return (
    <StyledMain>
      <Navigation {...navigation} />
      <StyledMainSection>
        {children}
      </StyledMainSection>
    </StyledMain>
  );
}

export default memo(AnonymousMain);